export const blockIconsTravelApartmentNew = (
	<span className='material-symbols-outlined'>apartment</span>
);
